import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=e85771e8"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports